const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Для чего применяется NeuroPlex Ultra?', acceptedAnswer: { '@type': 'Answer', text: 'NeuroPlex Ultra — нейропротекторный комплекс для улучшения когнитивных функций, памяти и концентрации. Применяется при умственных нагрузках, возрастных изменениях нервной системы и дефиците витаминов группы B.' } },
    { '@type': 'Question', name: 'Есть ли рецепт для покупки NeuroPlex Ultra?', acceptedAnswer: { '@type': 'Answer', text: 'Нет. NeuroPlex Ultra отпускается без рецепта врача. Вы можете приобрести его в нашей аптеке онлайн или заказать доставку.' } },
    { '@type': 'Question', name: 'Как принимать NeuroPlex Ultra?', acceptedAnswer: { '@type': 'Answer', text: 'По 1 капсуле 2 раза в день во время еды. Рекомендуемый курс — 30 дней. Повторный курс — через 2 месяца.' } },
    { '@type': 'Question', name: 'Можно ли принимать NeuroPlex Ultra при беременности?', acceptedAnswer: { '@type': 'Answer', text: 'Нет. NeuroPlex Ultra противопоказан при беременности и лактации. Перед применением проконсультируйтесь с врачом.' } },
    { '@type': 'Question', name: 'Есть ли аналоги NeuroPlex Ultra?', acceptedAnswer: { '@type': 'Answer', text: 'Да. К аналогам относятся Мемантин Про, ВитаМозг Макс, NeuroCaps X2 и Гинкго Форте. Все они представлены в нашем каталоге.' } },
  ],
};

const SeoBlocks = () => {
  const color = '#ff2d78';
  const faqs = [
    { q: 'Для чего применяется NeuroPlex Ultra?', a: 'NeuroPlex Ultra — нейропротекторный комплекс для улучшения когнитивных функций, памяти и концентрации. Применяется при умственных нагрузках, возрастных изменениях нервной системы и дефиците витаминов группы B.' },
    { q: 'Есть ли рецепт для покупки?', a: 'Нет. NeuroPlex Ultra отпускается без рецепта врача. Вы можете приобрести его в нашей аптеке онлайн или заказать доставку.' },
    { q: 'Как принимать NeuroPlex Ultra?', a: 'По 1 капсуле 2 раза в день во время еды. Рекомендуемый курс — 30 дней. Повторный курс — через 2 месяца.' },
    { q: 'Можно ли принимать при беременности?', a: 'Нет. NeuroPlex Ultra противопоказан при беременности и лактации. Перед применением проконсультируйтесь с врачом.' },
    { q: 'Есть ли аналоги NeuroPlex Ultra?', a: 'Да. К аналогам относятся Мемантин Про, ВитаМозг Макс, NeuroCaps X2 и Гинкго Форте. Все они представлены в нашем каталоге.' },
  ];

  return (
    <section className="py-16 px-4 md:px-8 lg:px-12" style={{ background: '#070710' }} itemScope itemType="https://schema.org/Product">
      <script type="application/ld+json">{JSON.stringify(FAQ_SCHEMA)}</script>
      <meta itemProp="name" content="NeuroPlex Ultra" />
      <meta itemProp="brand" content="NeonPharma" />
      <meta itemProp="sku" content="NP-ULT-500" />
      <div className="max-w-7xl mx-auto space-y-16">

        {/* About product SEO text */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <h2 className="font-orbitron font-black text-2xl text-white mb-6" id="about-product">
              <a href="#about-product">NeuroPlex Ultra — нейропротекторный комплекс</a>
            </h2>
            <div className="space-y-4 font-mono text-sm text-white/50 leading-relaxed">
              <p>
                <strong className="text-white/80">NeuroPlex Ultra</strong> — это инновационный нейропротекторный комплекс от компании NeonPharma Labs (Германия), разработанный для поддержки когнитивных функций мозга и нервной системы. Уникальная формула объединяет стандартизированный экстракт гинкго билоба 80мг, L-карнитин 250мг и полный комплекс нейровитаминов B1, B6, B12 в терапевтических дозировках.
              </p>
              <p>
                Регулярный приём <strong className="text-white/80">NeuroPlex Ultra</strong> способствует улучшению памяти и концентрации внимания, снижению нервного напряжения и хронической усталости. Препарат особенно актуален для людей, занятых интенсивным умственным трудом: программистов, студентов, руководителей.
              </p>
              <p>
                По результатам независимого рейтинга MedВестник 2026, <strong className="text-white/80">NeuroPlex Ultra</strong> занял 2-е место среди безрецептурных нейропротекторов по соотношению «состав — эффективность — цена». Препарат зарегистрирован в Государственном реестре лекарственных средств РФ (ЛП-005782).
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <div
              className="p-5 rounded-2xl"
              style={{ border: `1px solid ${color}20`, background: `${color}05` }}
            >
              <h4 className="font-orbitron font-bold text-sm text-white mb-3" id="quick-facts">
                <a href="#quick-facts">Кратко о препарате</a>
              </h4>
              <div className="space-y-2.5">
                {[
                  { label: 'Производитель', value: 'NeonPharma (Германия)' },
                  { label: 'Форма', value: 'Капсулы, таблетки' },
                  { label: 'Отпуск', value: 'Без рецепта' },
                  { label: 'Рейтинг', value: '4.9 / 5 (312 отзывов)' },
                  { label: 'Доставка', value: 'За 2 часа по Москве' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start justify-between gap-3">
                    <span className="font-mono text-[11px] text-white/30">{item.label}</span>
                    <span className="font-mono text-[11px] text-white/70 text-right">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="p-5 rounded-2xl"
              style={{ border: '1px solid rgba(57,255,20,0.2)', background: 'rgba(57,255,20,0.03)' }}
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line" style={{ color: '#39ff14', fontSize: '14px' }} />
                </div>
                <span className="font-orbitron font-bold text-xs" style={{ color: '#39ff14' }}>ГАРАНТИЯ ОРИГИНАЛА</span>
              </div>
              <p className="font-mono text-[11px] text-white/40 leading-relaxed">
                Все товары поставляются напрямую от официальных дистрибьюторов. Подлинность подтверждена сертификатами.
              </p>
            </div>
          </div>
        </div>

        {/* Schema.org Product structured data - visible SEO info */}
        <div
          className="p-6 rounded-2xl"
          style={{ border: `1px solid rgba(0,245,255,0.2)`, background: 'rgba(0,245,255,0.02)' }}
          itemScope
          itemType="https://schema.org/Offer"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-search-eye-line" style={{ color: '#00f5ff', fontSize: '18px' }} />
            </div>
            <h3 className="font-orbitron font-bold text-sm text-white" id="buy-info">
              <a href="#buy-info">Где купить NeuroPlex Ultra онлайн?</a>
            </h3>
          </div>
          <p className="font-mono text-sm text-white/50 leading-relaxed mb-4">
            Купить <strong className="text-white/70">NeuroPlex Ultra</strong> можно в нашей интернет-аптеке с доставкой по Москве за 2 часа или самовывозом из ближайшей аптеки. Цена на <strong className="text-white/70">NeuroPlex Ultra</strong> от <span style={{ color: '#00f5ff' }} itemProp="price" content="2490">2 490₽</span>. Гарантируем подлинность и качество. Заказ без рецепта, онлайн-оплата.
          </p>
          <meta itemProp="priceCurrency" content="RUB" />
          <meta itemProp="availability" content="https://schema.org/InStock" />
          <div className="flex flex-wrap gap-3">
            {['Без рецепта', 'Доставка 2 часа', 'Самовывоз сегодня', 'Оплата онлайн', 'Оригинальный товар'].map(tag => (
              <span
                key={tag}
                className="font-mono text-[11px] px-3 py-1.5 rounded-full"
                style={{ background: 'rgba(0,245,255,0.08)', color: '#00f5ff', border: '1px solid rgba(0,245,255,0.2)' }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Related categories */}
        <div className="pt-8 border-t border-white/5">
          <h3 className="font-orbitron font-bold text-sm text-white mb-4" id="related-categories">
            <a href="#related-categories">Похожие категории товаров</a>
          </h3>
          <div className="flex flex-wrap gap-2">
            {[
              { name: 'Нейропротекторы', url: '/catalog?category=Нейропротекторы' },
              { name: 'Витамины группы B', url: '/catalog?category=Витамины+и+БАД' },
              { name: 'Препараты для памяти', url: '/catalog?category=Нейропротекторы' },
              { name: 'БАД для мозга', url: '/catalog?category=Витамины+и+БАД' },
              { name: 'Гинкго билоба', url: '/catalog?search=гинкго' },
              { name: 'Магний', url: '/catalog?search=магний' },
            ].map(cat => (
              <a
                key={cat.name}
                href={cat.url}
                className="whitespace-nowrap font-mono text-xs px-4 py-2 rounded-full transition-all hover:opacity-80"
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.5)' }}
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>

        {/* FAQ Section with Schema.org */}
        <div className="pt-12 border-t border-white/5" itemScope itemType="https://schema.org/FAQPage">
          <h3 className="font-orbitron font-black text-xl text-white mb-6" id="faq">
            <a href="#faq">Часто задаваемые вопросы о {product.name}</a>
          </h3>
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="p-5 rounded-2xl"
                style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h4 className="font-orbitron font-bold text-sm text-white mb-2" itemProp="name">{faq.q}</h4>
                <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <p className="font-mono text-xs text-white/50 leading-relaxed" itemProp="text">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const product = { name: 'NeuroPlex Ultra' };

export default SeoBlocks;
